// @ts-ignore
import IdleTimer from 'idle-timer'
import Video from '../../Components/Video/Video'
import GameContainer from '../GameContainer/GameContainer'

class CinematicContainer {
    readonly container = document.querySelector('#cinematic-container') as HTMLDivElement
    readonly cinematicControls = document.querySelector('#cinematic-controls') as HTMLDivElement
    readonly pauseButton = document.querySelector('#cinematic-pause') as HTMLButtonElement
    readonly rewindButton = document.querySelector('#cinematic-rewind') as HTMLButtonElement
    readonly skipButton = document.querySelector('#cinematic-skip') as HTMLButtonElement
    video: Video | null = null

    // eslint-disable-next-line
    idleTimer: any

    constructor() {
        this.pauseButton.onclick = () => {
            if (this.video?.videoElement.paused) {
                this.play()
                this.pauseButton.innerHTML = '&#124;&#124;'
            } else {
                this.pause()
                this.pauseButton.innerHTML = '&#62;'
            }
        }

        this.rewindButton.onclick = () => {
            this.rewind()
        }

        this.skipButton.onclick = () => {
            this.skip()
        }
    }

    setIdleTimer = () => {
        this.idleTimer = IdleTimer({
            // function to fire after idle
            callback: this.hideControls,
            // function to fire when active
            activeCallback: this.showControls,
            // Amount of time in milliseconds before becoming idle. default 60000
            idleTime: 1234,
        })
    }

    removeIdleTimer = () => {
        this.idleTimer && this.idleTimer.destroy()
        this.idleTimer = null
    }

    hideControls = () => {
        this.cinematicControls.classList.add('mouse-idle')
        GameContainer.setMouseIdle(true)
        console.debug(`Inamove::Cinematic => idleTimeout: hide controls`)
    }

    showControls = () => {
        this.cinematicControls.classList.remove('mouse-idle')
        GameContainer.setMouseIdle(false)
        console.debug(`Inamove::Cinematic => idleTimeout: show controls`)
    }

    hide = () => {
        this.container.classList.add('hidden')
        this.removeIdleTimer()
    }

    show = () => {
        this.container.classList.remove('hidden')
    }

    setVideo = (video: Video) => {
        if (this.video !== null) {
            this.container.removeChild(this.video.videoElement)
        }

        this.video = video
        this.container.appendChild(this.video.videoElement)
    }

    load = async () => {
        if (!this.video) {
            console.error('>>>>> CinematicContainer: load: no video set!')
            return
        }

        return this.video.load()
    }

    play = async (showControls = true) => {
        showControls ? this.setIdleTimer() : this.hideControls
        await this.video?.play()
        this.removeIdleTimer()
        GameContainer.setMouseIdle(false)
        // TODO: Why here?
        this.video?.destroy()
        this.video = null
    }

    pause = () => {
        this.video?.pause()
    }

    skip = () => {
        this.video?.skip()
    }

    rewind = () => {
        if (this.video !== null) {
            this.video.videoElement.currentTime = 0
        }
    }
}

export default new CinematicContainer()
